import { IoChevronBack } from "react-icons/io5";
import { useAppDispatch, useAppSelector } from "../../../utils/hooks";
import { updateViewState } from "../../../store/Slices/ViewManagerSlice";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsAndCondition from "./TermsAndCondition";
import TextTranslate from "../../../utils/TextTranslate";

export default function PrivacyPolicyDrawer() {
  const viewImageSlice = useAppSelector((state) => state.ViewManager);
  const dispatch = useAppDispatch();

  const open =
    !!viewImageSlice?.showPrivacyPolicy ||
    !!viewImageSlice?.showTermsAndCondition;

  const title = viewImageSlice.showPrivacyPolicy
    ? "Privacy Policy"
    : "Terms & Conditions";

  function close() {
    dispatch(
      updateViewState({
        showTermsAndCondition: false,
        showPrivacyPolicy: false,
      }),
    );
  }

  return (
    <div
      className={`fixed inset-y-0 right-0 z-[60] flex h-[100dvh] w-full max-w-[100vw] flex-col overflow-hidden bg-secondary shadow-2xl transition-transform duration-300 ease-out lg:w-full lg:max-w-md xl:max-w-[28rem] ${
        open ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="sticky top-0 z-20 shrink-0 border-b border-black/[0.06] bg-secondary/85 backdrop-blur-xl dark:border-white/[0.08]">
        <div className="flex items-center justify-between px-3 py-3">
          <button
            type="button"
            aria-label="Back"
            className="grid h-9 w-9 place-content-center rounded-full bg-black/[0.06] text-darkText transition active:scale-95 dark:bg-white/10"
            onClick={close}
          >
            <IoChevronBack className="text-xl" />
          </button>
          <span className="max-w-[14rem] truncate text-center text-[17px] font-semibold tracking-tight text-darkText">
            <TextTranslate text={title} />
          </span>
          <div className="h-9 w-9" aria-hidden />
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-hidden bg-primary">
        {viewImageSlice.showPrivacyPolicy ? (
          <PrivacyPolicy embedded />
        ) : open ? (
          <TermsAndCondition embedded />
        ) : null}
      </div>
    </div>
  );
}
